import { memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import dayjs from 'dayjs';
import DateFilter from '../../../../Filters/DateSelectorFilter';
import { setTripSearchInputs } from '../../../../../store/slices/tripSearch';

const TourEndDateFilter = ({ doOpenDatePicker, setDoOpenDatePicker, tripId }) => {
  const isTripSearch = !tripId;
  const { searchInputs } = useSelector((store) => store.tripSearch);
  const dispatch = useDispatch();

  const handleChange = (value) => {
    if (value) {
      setDoOpenDatePicker(false);
    }
    const payload = {
      ...searchInputs,
    };
    payload.tour = {
      ...payload.tour,
    };
    payload.tour.endDate = value;
    dispatch(setTripSearchInputs({ ...payload }));
  };

  return (
    <DateFilter
      onChange={handleChange}
      label="Tours until"
      value={searchInputs.tour.endDate}
      defaultValue={searchInputs.tour.endDate}
      minDate={searchInputs.tour.startDate ? dayjs(searchInputs.tour.startDate) : dayjs()}
      variant={isTripSearch ? 'outline-no-radius' : 'outline'}
      filterButtonMaxWidth={clsx('max-w-full', { 'w-full': isTripSearch })}
      doOpenDatePicker={doOpenDatePicker}
      setDoOpenDatePicker={setDoOpenDatePicker}
      bgClassName={isTripSearch ? 'bg-searchInput-0' : undefined}
      textColorClassName={isTripSearch ? 'text-datepicker-0' : undefined}
    />
  );
};

TourEndDateFilter.propTypes = {
  doOpenDatePicker: PropTypes.bool,
  setDoOpenDatePicker: PropTypes.func,
  tripId: PropTypes.string,
};

TourEndDateFilter.defaultProps = {
  doOpenDatePicker: false,
  setDoOpenDatePicker: () => {},
  tripId: undefined,
};

export default memo(TourEndDateFilter);
